// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IsolationUnitSpecInput } from './IsolationUnitSpecInput';
import {
  IsolationUnitSpecInputFromJSON,
  IsolationUnitSpecInputFromJSONTyped,
  IsolationUnitSpecInputToJSON,
  IsolationUnitSpecInputToJSONTyped,
} from './IsolationUnitSpecInput';

/**
 *
 * @export
 * @interface UpdateIsolationUnitSpec
 */
export interface UpdateIsolationUnitSpec {
  /**
   *
   * @type {IsolationUnitSpecInput}
   * @memberof UpdateIsolationUnitSpec
   */
  spec?: IsolationUnitSpecInput;
}

/**
 * Check if a given object implements the UpdateIsolationUnitSpec interface.
 */
export function instanceOfUpdateIsolationUnitSpec(
  value: object,
): value is UpdateIsolationUnitSpec {
  return true;
}

export function UpdateIsolationUnitSpecFromJSON(
  json: any,
): UpdateIsolationUnitSpec {
  return UpdateIsolationUnitSpecFromJSONTyped(json, false);
}

export function UpdateIsolationUnitSpecFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UpdateIsolationUnitSpec {
  if (json == null) {
    return json;
  }
  return {
    spec:
      json['spec'] == null
        ? undefined
        : IsolationUnitSpecInputFromJSON(json['spec']),
  };
}

export function UpdateIsolationUnitSpecToJSON(
  json: any,
): UpdateIsolationUnitSpec {
  return UpdateIsolationUnitSpecToJSONTyped(json, false);
}

export function UpdateIsolationUnitSpecToJSONTyped(
  value?: UpdateIsolationUnitSpec | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    spec: IsolationUnitSpecInputToJSON(value['spec']),
  };
}
